import React from 'react'

export const OpenContext = React.createContext(-1)

export const ScrollContext = React.createContext({
    appHeight: null,
    onScroll: () => {},
    top: null,
    topThree: null,
})